import type { Component, DeepStructure, Structure } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'

export const buildDeepStructure = (comp: Component, flatStructure: Structure): DeepStructure => {
	// @ts-ignore
	const children = _(comp.children || comp.components)
		.concat(_.values(comp.slots))
		.compact()
		.value()

	if (!_.isEmpty(children)) {
		const components = _.map(children, (child) => buildDeepStructure(flatStructure[child], flatStructure))
		// @ts-ignore
		return _(comp)
			.omit(['components', 'parent'])
			.defaults({ [comp.id === 'masterPage' ? 'children' : 'components']: components })
			.value()
	}
	// @ts-ignore
	return _.omit(_.clone(comp), 'parent')
}
